import { GatewayType, getGateway } from "../../../gateways/gatewayRegistry";
import { AxiosResponse } from "axios";
import { IEventSchedulerData } from "../interfaces/event-scheduler.interface";

export const getEventScheduler = async ({ eventSchedulerUid }: { eventSchedulerUid: string }) => {
  try {
    if (!eventSchedulerUid) {
      throw new Error("Event scheduler UID is required");
    }
    
    const gateway = getGateway(GatewayType.EVENT_SCHEDULER);
    const url = `/event/${eventSchedulerUid}`;
    const fullUrl = `${gateway.defaults.baseURL}${url}`;
    
    console.log(`[getEventScheduler] Calling: ${fullUrl}`);
    
    const response = await gateway.get<IEventSchedulerData>(url);
    
    // NestJS returns data directly, not wrapped in { data: ... }
    return response.data;
  } catch (error) {
    console.error(`Error getting event scheduler ${eventSchedulerUid}`, error);
    throw error;
  }
};
